<template>
  <button
    class="btn btn-outline-primary finish-button"
    v-on:click="finishConfiguration"
  >
    Finish configuration
  </button>
</template>

<script>
  export default {
    name: "finish-configuration",
    data() {
      return {};
    },
    methods: {
      finishConfiguration: function() {
        this.$emit("finish-configuration");
      },
    }
  };
</script>

<style lang="scss" scoped>
@media (min-width: 768px) {
    .finish-button {
        margin-left: auto;
        margin-right: 16px;
    }
}
@media (max-width: 767.98px) {
    .finish-button {
        order: 12;
        flex: 1;
        margin-top: 24px;
    }
}
</style>

